module.exports = __webpack_public_path__ + "img/Grab Express.60412577.png";